import React, {useRef, ReactNode, CSSProperties} from "react"
import {useClickAway, useToggle} from "react-use"
import classNames from "classnames"
import Icon from "../Icon/Icon"

interface DropdownItem<T> {
	value: T
	key: string
	content: ReactNode
}

interface Props<T> {
	options: DropdownItem<T>[]
	selectedValue: T
	onSelect: (value: T) => void
	placeholder?: string
	className?: string
	style?: CSSProperties
	disabled?: boolean
	closeOnSelect?: boolean
	allowEmpty?: boolean // TODO implement
	isFullWidth?: boolean
	dropDownMenuClass?: string
}

export default function CustomDropdown<T>({
	options,
	selectedValue,
	onSelect,
	placeholder = "Select an option",
	className,
	disabled = false,
	closeOnSelect = true,
	isFullWidth = false,
	style,
	dropDownMenuClass,
}: Props<T>) {
	const ref = useRef(null)
	const [isActive, toggleIsActive] = useToggle(false)

	useClickAway(ref, () => toggleIsActive(false))

	const handleOptionClick = (event: React.MouseEvent, value: T) => {
		event.preventDefault()
		onSelect(value)
		if (closeOnSelect) toggleIsActive(false)
	}

	const selectedOption = options.find((option) => option.value === selectedValue)?.content

	return (
		<div
			className={classNames(
				"custom-dropdown",
				"dropdown",
				isActive && "is-active",
				className,
				isFullWidth && "full-width"
			)}
			style={style}
			ref={ref}
		>
			<div
				className="dropdown-trigger"
				onClick={() => {
					!disabled && toggleIsActive()
				}}
			>
				<button type="button" className="button" aria-haspopup="true" aria-controls="dropdown-menu" disabled={disabled}>
					<span className={"selected-option"}>{selectedOption || placeholder}</span>
					<span className="arrow-icon">
						<Icon icon="arrow-down-chevron" size={12} color={"#000"} />
					</span>
				</button>
			</div>
			{isActive && (
				<div className={classNames("dropdown-menu", dropDownMenuClass)} id="dropdown-menu" role="menu">
					<div className="dropdown-content">
						{/*TODO: implement*/}
						{/*{allowEmpty && (*/}
						{/*	<a*/}
						{/*		href="#"*/}
						{/*		className={classNames("dropdown-item", {"is-active": selectedValue === null})}*/}
						{/*		onClick={(event) => handleOptionClick(event, null)}*/}
						{/*	>*/}
						{/*		{placeholder}*/}
						{/*	</a>*/}
						{/*)}*/}
						{options.map((option) => (
							<a
								href="#"
								key={option.key}
								className={classNames("dropdown-item", {
									"is-active": option.value === selectedValue,
								})}
								onClick={(event) => handleOptionClick(event, option.value)}
							>
								{option.content}
								{option.value === selectedValue && (
									<Icon className="checkmark" icon="approve-v-check-validation" size={16} />
								)}
							</a>
						))}
					</div>
				</div>
			)}
		</div>
	)
}
